/**
 * Spend per task below which a segment sits in the cheapest quarter.
 * Lower is better, so the top quartile is p25 by linear interpolation.
 * Null when there is nothing to rank, which paints every bar neutral.
 */
export function computeTopQuartileThreshold(values: number[]): number | null {
  const finite = values.filter((value) => Number.isFinite(value));
  if (finite.length === 0) return null;

  const sorted = [...finite].sort((left, right) => left - right);
  if (sorted.length === 1) return sorted[0]!;

  const index = 0.25 * (sorted.length - 1);
  const lower = Math.floor(index);
  const upper = Math.ceil(index);
  const weight = index - lower;

  return sorted[lower]! * (1 - weight) + sorted[upper]! * weight;
}
